const ContentCommentContent = ({ content, taggedUsers, className = "" }) => {
  return <p className={className}>{content}</p>;
};

export default ContentCommentContent;
